import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { ConfigGlobal } from './core/interfaces/globals/config-global.interfaces';
import { CustomTranslateLoaderService } from './core/services/translations/custom-translate-loader.service';

import { LOCATION_INITIALIZED } from '@angular/common';
import { APP_INITIALIZER, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppUserAuth } from './core/interfaces/auth/login.interfaces';

function langToSemsaLang(language: string): string {
  switch (language) {
    case 'nl':
      return 'semsa_1';
    case 'fr':
      return 'semsa_2';
    case 'en':
      return 'semsa_3';
    default:
      return 'semsa_3';
  }
}

/**
 * Wait to initialize the app until the translations are available.
 * @param translate
 * @param injector
 * @returns
 */
function appInitializerFactory(
  translate: TranslateService,
  injector: Injector,
) {
  return () =>
    new Promise<any>((resolve: any) => {
      const locationInitialized = injector.get(
        LOCATION_INITIALIZED,
        Promise.resolve(null),
      );
      locationInitialized.then(() => {
        const userAuth: AppUserAuth = JSON.parse(
          localStorage.getItem('currentUser_semsa'),
        );
        const language = userAuth?.language?.name ?? translate.getBrowserLang();
        const langToSet = langToSemsaLang(language);
        translate.setFallbackLang('semsa_1');

        translate.use(langToSet).subscribe(
          () => {
            console.info(
              `Successfully initialized '${langToSet}' (${language}) language.`,
            );
          },
          (err) => {
            console.error(
              `Problem with '${langToSet}' language initialization.'`,
            );
          },
          () => {
            resolve(null);
          },
        );
      });
    });
}

const config: ConfigGlobal = {
  server: environment.server,
  apiRoot: environment.apiRoot,
  appOrigin: 'client',
  ubieAppUrl: environment.ubieAppUrl,
  luqasWizardVersion: environment.luqasWizardVersion,
};

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({ innerHTMLTemplatesEnabled: true }),
    AppRoutingModule,
    CoreModule.forRoot(config),
    BrowserAnimationsModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    // ngx-translate 18 dropped TranslateModule in favour of this provider.
    provideTranslateService({
      fallbackLang: 'semsa_1',
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoaderService,
        deps: [HttpClient],
      },
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, Injector],
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
